import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
var perceptionCode = {
  PHiuUt: "诈骗",
  orTPeJ: "中介/二房东"
};
export default {
  mixins: [userPopMixin],
  name: "DetailUserInfo",
  props: {
    info: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      remarkVisible: false,
      remark: "",
      deviceRisk: {},
      userTag: []
    };
  },
  computed: {
    getPerceptionCodeName: function getPerceptionCodeName() {
      return perceptionCode[this.deviceRisk.perception_code] ? perceptionCode[this.deviceRisk.perception_code] : "";
    }
  },
  watch: {
    info: {
      immediate: true,
      handler: function handler(val) {
        if (val !== null && val !== void 0 && val.id) {
          this.getUserDeviceRisk();
          this.getUsersTagList();
        }
      }
    }
  },
  methods: {
    getUsersTagList: function getUsersTagList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var id, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              id = _this.info.id;
              _context.n = 1;
              return _this.$api.getUsersTagList({
                top: 5,
                user_id: id
              });
            case 1:
              res = _context.v;
              if (res.data[id]) {
                _this.userTag = res.data[id];
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    goDeviceList: function goDeviceList() {
      window.open("#/user/deviceId?phone=".concat(this.info.phone));
    },
    showRemark: function showRemark() {
      this.remark = this.info.remark;
      this.remarkVisible = true;
    },
    getUserDeviceRisk: function getUserDeviceRisk() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var id, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              id = _this2.info.id;
              _context2.n = 1;
              return _this2.$api.getUserDeviceRisk({
                user_id: id
              });
            case 1:
              res = _context2.v;
              _this2.deviceRisk = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    confirmClose: function confirmClose() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.remarkVisible = false;
              _context3.n = 1;
              return _this3.$api.setUserRemark({
                remark: _this3.remark,
                userId: _this3.info.id
              });
            case 1:
              res = _context3.v;
              if (res !== null && res !== void 0 && res.ret) {
                _this3.$message.success("更新备注成功");
                _this3.remark = "";
                _this3.$emit("update");
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getData: function getData() {},
    onCopy: function onCopy() {
      this.$message.success("复制成功");
    },
    onError: function onError() {
      this.$message.error("复制失败");
    }
  }
};